import axios from "axios";
import { API_ROOT } from "../../constants/constant";
import { getAccessToken } from "../../utils/okta-config";
import { useEffect, useState } from "react";

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [error, setError] = useState(null);

  const sendRequest = async (requestConfig, applyData) => {
    const { method, url, data, params, customErrorMsg } = requestConfig;
    setIsLoading(true);
    setErrorMsg(null);

    const accessToken = getAccessToken();
    const headers = {
      "Access-Control-Allow-Origin": API_ROOT,
      Authorization: `Bearer ${accessToken}`,
    };

    try {
      const response = await axios({ method, url, data, headers, params });
      if (response.status === 200) {
        const reponseData = await response.data;
        applyData(reponseData, reponseData.message);
      }
    } catch (error) {
      setIsLoading(false);
      const beMsg = error?.response?.data?.message;
      const message = beMsg
        ? beMsg === "No message available" || beMsg.length > 60
          ? customErrorMsg
          : beMsg
        : customErrorMsg;
      setErrorMsg(message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setError(errorMsg);
  }, [errorMsg]);
  return {
    isLoading,
    sendRequest,
    error,
  };
};

export default useHttp;
